import React from 'react'
import { useTranslation } from 'react-i18next'
import { useOutletContext } from 'react-router'
import { useParams } from 'react-router-dom'
import { MarkLearningItemAsFinishedDialog } from '../../components/learningAssignmentForms/MarkLearningItemAsFinishedDialog/MarkLearningItemAsFinishedDialog'

export default React.memo(function MarkLearningItemAsFinishedPage() {
  const { uuid, learningItemUuid } = useParams()

  const { close } = useOutletContext<any>()

  return <MarkLearningItemAsFinishedDialog userUuid={uuid!} learningItemUuid={learningItemUuid!} close={close} />
})

export function MarkLearningItemAsFinishedPageBreadcrumb() {
  const { t } = useTranslation()
  return <span>{t('manage learning.mark as finished.breadcrumb')}</span>
}
